import React from 'react'
import { map } from 'ramda'

import { ACCESS_SECTIONS, categoriseAccesses } from '../accesses'

import AccessCard from './AccessCard'
import NavBar, { NavItem } from './NavBar'
import PageTitle from './PageTitle'
import TPPNotification from './TPPNotification'

import style from './Accesses.module.scss'
import CategorisedConsents from './CategorisedConsents'

export default function Accesses({ handleDisplayStatusesMeaning, tpp }) {
  const consents = tpp.get('consents')
  const sections = map(generateSectionMetaData(consents), ACCESS_SECTIONS)

  return (
    <section className="zb-container js-accesses">
      <NavBar
        items={[
          new NavItem({
            label: 'Access',
            link: '/access-agreements/tpps',
          }),
        ]}
        padded
      />
      <header className={`${style.tppHeader} js-header`}>
        <PageTitle consentType="access" label={tpp.get('clientDisplayName')} />
      </header>
      <TPPNotification tpp={tpp} />
      <CategorisedConsents
        sections={sections}
        Card={AccessCard}
        consents={consents}
        consentType="access"
        handleDisplayStatusesMeaning={handleDisplayStatusesMeaning}
        tpp={tpp}
      />
    </section>
  )
}

function generateSectionMetaData(allConsents) {
  const consentsBySection = allConsents.groupBy(categoriseAccesses)

  return section => {
    const consents = consentsBySection.get(section)
    return {
      ...section,
      consents,
      noOfConsents: consents ? consents.size : 0,
    }
  }
}
